import { render } from "./CountryCard.vue?vue&type=template&id=2580448d&scoped=true"
import script from "./CountryCard.vue?vue&type=script&lang=js"
export * from "./CountryCard.vue?vue&type=script&lang=js"

import "./CountryCard.vue?vue&type=style&index=0&id=2580448d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2580448d"

export default script